<template>
  <div>
    <DashboardTabs v-if="displayDashboardTabs" />
    <DashboardSideMenu v-if="displayDashboardSideMenu" />

    <router-view />

    <RecruitmentRecapModal />
  </div>
</template>

<script>
import { RouterHelpers } from "@core/helpers";
import { META_DASHBOARD_TABS, META_DASHBOARD_SIDEMENU } from "@etab/config";

import RecruitmentRecapModal from "@etab/components/recruitments/detail/RecruitmentRecap.modal.vue";
import DashboardSideMenu from "./DashboardSideMenu.component.vue";
import DashboardTabs from "./DashboardTabs.component.vue";

export default {
  components: {
    DashboardSideMenu,
    DashboardTabs,
    RecruitmentRecapModal,
  },
  computed: {
    displayDashboardTabs() {
      return this.$q.screen.lt.sm && RouterHelpers.getRouteMeta(this.$route, META_DASHBOARD_TABS);
    },
    displayDashboardSideMenu() {
      return this.$q.screen.gt.xs && RouterHelpers.getRouteMeta(this.$route, META_DASHBOARD_SIDEMENU);
    },
  },
};
</script>
